import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core'
import * as CryptoJS from 'crypto-js'
import { environment } from '../../../../../environments/environment'

@Directive({
  selector: '[gdAdminOnly]',
  standalone: true
})
export class AdminOnlyDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    const isAdmin = this.checkIfAdmin()

    if (!isAdmin) {
      // Disable the button if user is not admin
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true')
      this.renderer.addClass(this.el.nativeElement, 'k-disabled')
    }
  }

  private checkIfAdmin(): boolean {
    const storageValue = localStorage.getItem('rvarietylist')

    if (!storageValue) {
      return false
    }

    try {
      const decryptedRole = CryptoJS.AES.decrypt(
        storageValue,
        environment.securepw,
      ).toString(CryptoJS.enc.Utf8)

      return decryptedRole?.toLowerCase().includes('admin')
    } catch (error) {
      console.error('Error decrypting role in AdminOnlyDirective:', error)
      return false
    }
  }
}
